document.addEventListener("DOMContentLoaded", function() {
    var tooltips = document.querySelectorAll('.functionalities-item__label.has-tooltip');

    tooltips.forEach(function(label) {
        label.addEventListener('click', function() {
            var tooltipContent = label.querySelector('.tooltip-content');
            
            if (tooltipContent) {
                tooltipContent.classList.toggle('open');
            }
        });
    });
});
